import moment from 'moment';
import Logomarca from "../../assets/images/logomarca1.png";
import Facebook from "../../assets/images/icone-facebook.png";
import Instagram from "../../assets/images/icone-instagram.png";
import Linkedin from "../../assets/images/icone-linkedin.png";
import Youtube from "../../assets/images/icone-youtube.png";
import { useState, useEffect } from "react";

const Banner = () => {
  const [horas, setHoras] = useState(0);
  const [minutos, setMinutos] = useState(0);
  const [segundos, setSegundos] = useState(0);
  const eventDate = moment('2023-10-27 08:00:00');

  // TIMER
  useEffect(() => {
    setInterval(() => {
      const now = moment();
      const diff = moment.duration(eventDate.diff(now));
      
      const hours = Math.floor(diff.asHours());
      const minutes = Math.floor(diff.asMinutes()) - hours * 60;
      const seconds = Math.floor(diff.asSeconds()) - hours * 60 * 60 - minutes * 60;

      setHoras(hours > 0 ? hours : '00');
      setMinutos(hours > 0 ? (minutes <= 9 ? ('0' + minutes) : minutes) : '00');
      setSegundos(hours > 0 ? (seconds <= 9 ? ('0' + seconds) : seconds) : '00');
    }, 1000)
  }, [])

  return (
    <>
      <section id="banner">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-5 mr-2 my-4 logo">
              <div className="logomarca d-flex justify-content-center w-100">
                <img
                  src={Logomarca}
                  width='70%'
                  className="img-fluid"
                  alt="Líderes do Sucesso Team Edition 2021"
                />
              </div>
            </div>

            <div className="col-12 col-lg-6 d-flex flex-column gap-0 justify-content-center timer">
              <h6
                className="text-uppercase text-white m-0"
                style={{ fontWeight: 400, fontSize: "1.5rem", marginTop: '0', marginBottom: '-20px !important' }}
              >
                A revolução começa em:
              </h6>

              <div className="timer d-flex gap-5">
                <div
                  id="horas"
                  className="d-flex flex-column align-items-center"
                >
                  <h1 className="text-white m-0" style={{ fontSize: "6rem" }}>
                    {horas}
                  </h1>
                  <span
                    className="text-white descTempo"
                    style={{ fontSize: "1.5rem", marginTop: "-10px" }}
                  >
                    Horas
                  </span>
                </div>

                <div
                  id="minutos"
                  className="d-flex flex-column align-items-center"
                >
                  <h1 className="text-white m-0" style={{ fontSize: "6rem" }}>
                    {minutos}
                  </h1>
                  <span
                    className="text-white descTempo"
                    style={{ fontSize: "1.5rem", marginTop: "-10px" }}
                  >
                    Minutos
                  </span>
                </div>

                <div
                  id="segundos"
                  className="d-flex flex-column align-items-center"
                >
                  <h1 className="text-white m-0" style={{ fontSize: "6rem" }}>
                    {segundos}
                  </h1>
                  <span
                    className="text-white descTempo"
                    style={{ fontSize: "1.5rem", marginTop: "-10px" }}
                  >
                    Segundos
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className="row justify-content-center"
        style={{ backgroundColor: "#000", width: '100%', margin: 0 }}
        id="redesSociais"
      >
        <div
          id="listaRedes"
          className="col-10 col-sm-8 col-md-5 col-lg-4 d-flex justify-content-center align-items-center"
          style={{
            height: "60px",
            backgroundColor: "#F89E32",
            borderRadius: "40px",
            marginTop: "-30px",
          }}
        >
          <div className="w-75 d-flex justify-content-between">
            <a
              aria-current="page"
              href="https://www.facebook.com/premiumclubeoficial/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Facebook} alt="Facebook Líderes do Sucesso" />
            </a>

            <a
              aria-current="page"
              href="https://www.instagram.com/premiumclubeoficial/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Instagram} alt="Instagram Líderes do Sucesso" />
            </a>

            <a
              aria-current="page"
              href="https://www.linkedin.com/company/premium-clube/mycompany/"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Linkedin} alt="Linkedin Líderes do Sucesso" />
            </a>

            <a
              aria-current="page"
              href="https://www.youtube.com/channel/UCCRvg9MYF6b6s42SyJva1Dw"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Youtube} alt="Youtube Líderes do Sucesso" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
